import * as Api from '../../../api/Api';
import TableFromServer from "../../../Components/Table/TableFromServer";
import { useGetToken } from '../../../Hooks/CustomHooks';
import * as Utilities from '../../../Components/Utils/Utils';
import AgTable from '../../../Components/Table/AgTable';

export default function EvolucionVentasTiendaTotales({ unidadEconomicaId, mesCierre, anio }) {
    let headers = [
        {
            headerName: 'Contrato',
            field: 'contratoId',
        },

        {
            headerName: 'Den. Contrato',
            field: 'contratoDenominacion',
        }
    ];
    for (let i = 1; i <= 12; i++) {
        headers.push({
            headerName: Utilities.getHeaderMonth(mesCierre, anio, i),
            field: 'mes' + (i),
            type: 'rightAligned',
            cellRenderer: (props) => (
                <>{Utilities.comillasFix(props.data[`mes${i}`], true)}</>
            )
        });
    }

    return (
        <AgTable
            idContent={"EvolucionVentasTiendaTotales " + unidadEconomicaId + mesCierre + anio}
            apiService={Api.EvolucionVentasTiendaTotales}
            setAuxData={null}
            header={headers}
            titleExcel={"EvolucionVentasTiendaTotales - " + unidadEconomicaId + " " + mesCierre + " " + anio}
            conditions={true}
            args={{
                unidadEconomicaId: unidadEconomicaId,
                mesCorte: mesCierre,
                anio: (anio + 1),
                token: useGetToken()
            }}
            hideFilter={false}
            paginationPageSize={8}
            rowHeight={40}
            useFlex={false}
        />
    )
}